module.exports = __webpack_public_path__ + "img/avatar.2dbb9464.png";